module.exports = new __parcel__URL__("pvp_heal_button.c88bbc04.png").toString();